import ValidationInterface from '@/plans/common/validation-interface';
import { ZoomPhoneCategories } from '@/common/persist-cart/categories';

export default class extends ValidationInterface {
  async requires() {
    return [];
  }

  async conflicts() {
    return [...ZoomPhoneCategories.map((c) => [c])];
  }
}
